import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, withLatestFrom } from 'rxjs';
import * as fromRoot from '@app/reducers/index';
import { Store } from '@ngrx/store';
import { ThemeActions } from '@app/core/actions';
import { ThemeSimplified } from '@app/shared/helpers/theme';


@Injectable({
    providedIn: 'root'
})
export class ResolveThemeService {

    constructor(
        private readonly store$: Store<fromRoot.State>,
    ) { }

    resolve({ target }: { target: ThemeSimplified['target'] }): Observable<{ theme: ThemeSimplified; }> {
        const resolvedTheme$ = new ReplaySubject<{ theme: ThemeSimplified; }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromRoot.getTheme),
                this.store$.select(fromRoot.getThemeLoading),
                this.store$.select(fromRoot.getThemeLoaded),
            ),
            takeUntil(resolvedTheme$)
        ).subscribe(([store, theme, themeLoading, themeLoaded]) => {
            if (theme) {
                resolvedTheme$.next({ theme });
            } else if (!themeLoading && !themeLoaded) {
                this.store$.dispatch(ThemeActions.LoadTheme({ target }));
            }
        });

        return resolvedTheme$.asObservable();
    }
}